import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {CanOrder} from '../../CanOrder';
import {Choice} from '../../../shared-gen/Model/Products/Choice';
import {ProductBase} from '../../../shared-gen/Model/Products/ProductBase';
import {DeviceStatusFun} from '../../../shared/device/device-status.fun';
import {AppService} from '../../services/app.service';
import { formatIoCurrency } from "../../../shared/pipes/currency.pipe";
import {Product} from "../../../shared-gen/Model/Products/Product";

@Component({
	selector: 'app-product-detail',
	templateUrl: './product-detail.component.html',
	styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent extends CanOrder implements OnInit, OnDestroy {

	static lastSelectedProduct: Product | null = null;

	product: ProductBase;

	details: { left: string, right: string } = {
		left: null,
		right: null
	};

	constructor(public dialogRef: MatDialogRef<ProductDetailComponent>,
	            app: AppService) {
		super(app);
	}

	async ngOnInit() {
		this.app.nav.setDoNotNavigate(true);
		await super.ngOnInit();

		if (this.product.Details) {
			const sep = '<hr />';
			const details = this.app.translation.translateProduct(this.product, "Details");
			if (details.includes(sep)) {
				const t = details.split(sep);
				this.details.left = t[0];
				t.splice(0, 1);
				this.details.right = t.join(sep);
			}
			else {
				this.details.left = details;
				this.details.right = "";
			}
		}


	}

	ngOnDestroy() {
		super.ngOnDestroy();
		this.app.nav.setDoNotNavigate(false);
	}

	close() {
		this.app.nav.setDoNotNavigate(false);
	}

	hasInstanceOfChoice(choice: Choice) {
		return this.product.Instances.findIndex(it => it.ID === `${this.product.ID}-${choice.ID}`) !== -1;
	}

	getInstanceOfChoice(choice: Choice) {
		if (choice === null) {
			return this.product.Instances[0];
		}
		return this.product.Instances.find(it => it.ID === `${this.product.ID}-${choice.ID}`);
	}

	choiceAvailable(choice: Choice) {
		const product = this.getInstanceOfChoice(choice);
		return this.productIsAvailable(product);
	}

	orderByChoice(choice: Choice, event) {
		event.stopPropagation();
		this.reportActivity();
		//TODO wie funktionieren zukünftig verschachtelte optionen?
		const instance = this.getInstanceOfChoice(choice);
		if (!instance) {
			return false;
		}
		//this.order(instance); // No, set lastSelectedProduct instead
		ProductDetailComponent.lastSelectedProduct = instance;
		this.closeDialog();
	}

	getPriceOfChoice(choice: Choice): string {
		let price = this.getPrice(this.getInstanceOfChoice(choice));
		return formatIoCurrency(price / 100, this.app.getCurrency());
	}

	choiceHasDeposit(choice: Choice): boolean {
		const instance = this.getInstanceOfChoice(choice);
		let deposit = this.getDeposit(instance);
		return deposit > 0;
	}

	getDepositOfChoice(choice: Choice): string {
		const instance = this.getInstanceOfChoice(choice);
		let deposit = this.getDeposit(instance);
		return formatIoCurrency(deposit / 100, this.app.getCurrency());
	}

	async reportActivity() {
		if (DeviceStatusFun.getVmcState(this.deviceStatus) === 'Inactive') {
			console.log('reset inactive timer');
			await this.app.status.reportUserActivity();
		}
	}

	back() {
		ProductDetailComponent.lastSelectedProduct = null;
		this.closeDialog();
	}

	closeDialog() {
		this.reportActivity();
		this.dialogRef.close();
	}
}
